import { createStyles, makeStyles } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const useStyles = makeStyles((theme) =>
  createStyles({
    mainCont: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      height: '50vh',
      paddingTop: 100,
      alignSelf: 'end',
    },
    messageCont: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    input: {
      marginTop: 20,
      fontWeight: 400,
      fontSize: 18,
      width: 300,
      borderRadius: 8,
      border: `1px solid ${COLORS.PRIMARY}`,
      '& input': {
        '&::placeholder': {
          fontSize: 18,
        },
      },
      '& .MuiInputBase-root': {
        padding: 8,
        borderRadius: 8,
        border: `1px solid ${COLORS.PRIMARY}`,
        fontSize: 18,
      },

      '& .MuiFormHelperText-root': {
        marginLeft: 0,
        fontSize: 18,
      },
    },
  }),
);
